import React from 'react';

// Wrap in forwardRef so react-hook-form's `register(...)` ref reaches the
// underlying <input>. Without this, the form has no reference to the DOM
// node, can't read the typed value, and required-field validation fires
// on submit even when the user filled in the fields.
const Input = React.forwardRef(function Input({
  label,
  error,
  className = '',
  type = 'text',
  prefix,
  suffix,
  ...props
}, ref) {
  return (
    <div className="w-full">
      {label && <label className="label">{label}</label>}
      <div className="relative flex items-center">
        {prefix && (
          <span className="absolute left-3 text-text-muted text-sm pointer-events-none">{prefix}</span>
        )}
        <input
          ref={ref}
          type={type}
          className={`input-base ${prefix ? 'pl-8' : ''} ${suffix ? 'pr-8' : ''} ${error ? 'border-danger/50 ring-1 ring-danger/30' : ''} ${className}`}
          {...props}
        />
        {suffix && (
          <span className="absolute right-3 text-text-muted text-sm pointer-events-none">{suffix}</span>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
});

export default Input;

export const Select = React.forwardRef(function Select({
  label,
  error,
  children,
  className = '',
  ...props
}, ref) {
  return (
    <div className="w-full">
      {label && <label className="label">{label}</label>}
      <select
        ref={ref}
        className={`input-base ${error ? 'border-danger/50' : ''} ${className}`}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
});

export const Textarea = React.forwardRef(function Textarea({
  label,
  error,
  className = '',
  ...props
}, ref) {
  return (
    <div className="w-full">
      {label && <label className="label">{label}</label>}
      <textarea
        ref={ref}
        className={`input-base resize-none ${error ? 'border-danger/50' : ''} ${className}`}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
});

export const Checkbox = React.forwardRef(function Checkbox({
  label,
  id,
  error,
  className = '',
  ...props
}, ref) {
  return (
    <div className="flex items-center gap-2">
      <input
        ref={ref}
        type="checkbox"
        id={id}
        className={`w-4 h-4 rounded border-white/20 bg-bg-input accent-accent cursor-pointer ${className}`}
        {...props}
      />
      {label && <label htmlFor={id} className="text-sm text-text-main cursor-pointer">{label}</label>}
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
});
